export default class MenuMain {
  constructor(element) {
    this.el = element
    this.burger = this.el.querySelector('#menuburger');
    this.menuSlider = this.el.querySelector('#menu-slider');
    this.burgerContainer = this.el.querySelector("[data-burgercontainer]");
    this.init()
  }
  
  init() {
    this.burger.addEventListener("change", e =>{
      this.menuSlider.classList.add("duration-500")
      if (this.burger.checked){
        this.burgerContainer.ariaExpanded = !JSON.parse(this.burgerContainer.ariaExpanded);
        this.menuSlider.classList.remove("translate-x-full")
        this.menuSlider.classList.add("translate-x-0");
        this.menuSlider.addEventListener('transitionend', () => {
        this.menuSlider.classList.remove("duration-500");})
      }else{
        this.burgerContainer.ariaExpanded = !JSON.parse(this.burgerContainer.ariaExpanded, "false");
        this.menuSlider.classList.remove("translate-x-0")
        this.menuSlider.classList.add("translate-x-full")
      }
    })
  }
}